<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--页头-->
							<div class="page_header">
								{{ pageTitle }}
							</div>
							<!--页头-->
							<div class="page_main">
								<div class="training-page">
									<!-- 顶部信息 -->
									<div class="top-info">
										<div class="info-item">
											<div class="info-label">
												{{ pageType == "overview" ? "General Training Item" : "Training Overview" }}
											</div>
											<div class="info-link">
												{{ recordName }}
											</div>
										</div>
									</div>
									<!-- 未完成的培训 -->
									<div class="card-block">
										<div class="block-header">
											<div class="block-title">
												Incomplete Training
											</div>
										</div>
										<el-table
											ref="unfinishedTable"
											:data="unfinishedList" border stripe row-key="id"
											@selection-change="handleUnfinishedSelectionChange"
											class="custom-table"
											header-cell-class-name="custom-header"
										>
											<el-table-column type="selection" width="55" align="center" />
											<el-table-column prop="username" label="User" min-width="180" />
											<!-- <el-table-column prop="" label="Company Name" min-width="260">
												<template slot-scope="scope">
													{{ scope.row.company_name || '' }}
												</template>
											</el-table-column> -->
											<el-table-column prop="" label="Department Name" min-width="180">
												<template slot-scope="scope">
													{{ scope.row.departments || '' }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Item ID" min-width="210">
												<template slot-scope="scope">
													{{ scope.row.item_name || 'N/A' }}
												</template>
											</el-table-column>
											<el-table-column prop="leixing_name" label="Training Item Type" min-width="160" />
											<el-table-column prop="" label="Training Deadline" min-width="160">
												<template slot-scope="scope">
													{{ initTime(scope.row.end_time) }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Assigned Self-Completion" min-width="210">
												<template slot-scope="scope">
													{{ scope.row.is_assigned == 1 ? 'Yes' : 'No' }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Requires Certification?" min-width="180">
												<template slot-scope="scope">
													{{ scope.row.is_certification == 1 ? 'Yes' : 'No' }}
												</template>
											</el-table-column>
											<el-table-column prop="purpose" label="Purpose" min-width="120">
												<template slot-scope="scope">
													{{ scope.row.purpose == 1 ? 'Initial Training' : 'Retraining' }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Monitor" min-width="180">
												<template slot-scope="scope">
													{{ scope.row.monitor_username || 'N/A' }}
												</template>
											</el-table-column>
											<el-table-column label="Action" width="80" align="center" fixed="right">
												<template slot-scope="scope">
													<el-link type="primary" :underline="false" @click="handleInfo(scope.row)">
														Details
													</el-link>
												</template>
											</el-table-column>
										</el-table>
									
										<div class="action-row">
											<el-button type="primary" size="medium" :disabled="!canEditButton" @click="handleMarkComplete">
												Mark Training Complete
											</el-button>
											<el-button type="primary" size="medium" :disabled="!canEditButton" @click="handleChangeDeadline">
												Modify Training Deadline
											</el-button>
											<el-button type="primary" size="medium" :disabled="!canEditButton" @click="handleAssignSelfComplete">
												Assign User to Complete Training
											</el-button>
											<div style="display: inline-block" v-if="canEditButton">
												<el-button type="primary" size="medium" @click="handleCancelAssignSelfComplete">
													Cancel Self-Completion Assignment
												</el-button>
											</div>
										</div>
									</div>
									<!-- 未完成认证 -->
									<div class="card-block mt24">
										<div class="block-header">
											<div class="block-title">
												Incomplete Certification
											</div>
										</div>
										<el-table ref="unverifiedTable" :data="unverifiedList" border stripe row-key="id"
										@selection-change="handleUnverifiedSelectionChange" class="custom-table"
										header-cell-class-name="custom-header">
											<el-table-column type="selection" width="55" align="center" />
											<el-table-column prop="username" label="User" min-width="180" />
											<!-- <el-table-column prop="" label="Company Name" min-width="260">
												<template slot-scope="scope">
													{{ scope.row.company_name || '' }}
												</template>
											</el-table-column> -->
											<el-table-column prop="" label="Department Name" min-width="180">
												<template slot-scope="scope">
													{{ scope.row.departments_name || '' }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Item ID" min-width="210">
												<template slot-scope="scope">
													{{ scope.row.item_name || 'N/A' }}
													</template>
											</el-table-column>
											<el-table-column prop="purpose" label="Purpose" min-width="160">
												<template slot-scope="scope">
													{{ scope.row.purpose == 1 ? 'Initial Training' : 'Retraining' }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Certification Deadline" min-width="180">
												<template slot-scope="scope">
													{{ initTime(scope.row.certification_end_time) }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Certification Method" min-width="180" fixed="right">
												<template slot-scope="scope">
													{{ scope.row.certification_method || '' }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Certification Evidence Files" min-width="150" fixed="right">
												<template slot-scope="scope">
													<div v-for="(value, index) in scope.row.image_list" :key="index" style="padding: 4px 0;">
														<a :href="value.url" target="_blank">{{ value.name }}</a>
													</div>
												</template>
											</el-table-column>
											<el-table-column prop="" label="Monitor" min-width="180">
												<template slot-scope="scope">
													{{ scope.row.monitor_username || 'N/A' }}
												</template>
											</el-table-column>
											<el-table-column label="Action" width="80" align="center" fixed="right">
												<template slot-scope="scope">
													<el-link type="primary" :underline="false" @click="handleInfo(scope.row)">
														Details
													</el-link>
												</template>
											</el-table-column>
										</el-table>
									
										<div class="action-row">
											<el-button :disabled="!unverifiedBtn" type="primary" size="medium" @click="handleCerProgress">
												Record Certification Progress
											</el-button>
											<el-button :disabled="!unverifiedBtn" type="primary" size="medium" @click="handleCerComplete">
												Mark Certification Complete
											</el-button>
											<el-button :disabled="!unverifiedBtn" type="primary" size="medium" @click="handleCerDeadline">
												Modify Certification Deadline
											</el-button>
										</div>
									</div>
									<!-- 被分配此培训要求的用户 -->
									<div class="card-block mt24">
										<div class="block-header">
											<div class="block-title">
												Users Assigned This Training Requirement
											</div>
										</div>
										<el-table ref="assignedTable" :data="assignedList" border stripe class="custom-table"
										header-cell-class-name="custom-header">
											<el-table-column v-if="pageType == 'overview'" label="Action" width="80" align="center">
												<template slot-scope="scope">
													<el-button type="primary" size="mini" @click="handleEdit(scope.row)">
														Edit
													</el-button>
												</template>
											</el-table-column>
									
											<el-table-column prop="username" label="User" />
									
											<!-- <el-table-column prop="" label="Company Name" min-width="">
												<template slot-scope="scope">
													{{ scope.row.company_name || '' }}
												</template>
											</el-table-column> -->
									
											<el-table-column prop="" label="Department Name" min-width="">
												<template slot-scope="scope">
													{{ scope.row.departments_name || '' }}
												</template>
											</el-table-column>
									
											<el-table-column v-if="pageType == 'overview'" prop="" label="Requires Certification?" width="120">
												<template slot-scope="scope">
													{{ scope.row.is_certification == 1 ? 'Yes' : 'No' }}
												</template>
											</el-table-column>
									
											<el-table-column label="Action" width="100" align="center">
												<template slot-scope="scope">
													<el-button type="danger" size="mini" @click="handleDelete(scope.row)">
														Delete
													</el-button>
												</template>
											</el-table-column>
										</el-table>
									
										<div class="action-row">
											<el-button type="primary" size="medium" @click="handleAssignOtherUser">
												Assign Other Users
											</el-button>
										</div>
									</div>
									<!-- 培训要求 -->
									<div class="card-block mt24" v-if="pageType === 'demand'">
										<div class="block-header">
											<div class="block-title">
												Training Requirements
											</div>
										</div>
										<el-table :data="trainingRequirementList" border stripe class="custom-table"
										header-cell-class-name="custom-header">
											<el-table-column prop="item_name" label="Item ID" min-width="220" />
											<el-table-column prop="leixing_name" label="Training Item Type" min-width="220" />
											<el-table-column prop="is_certification_name" label="Requires Certification?" min-width="180" />
										</el-table>
									</div>
									<!-- 符合此培训要求的培训概况 -->
									<div class="card-block mt24" v-if="pageType === 'overview'">
										<div class="block-header">
											<div class="block-title">
												Training Overview That Meets This Training Requirement
											</div>
										</div>
										<el-table ref="sourceData" :data="sourceData" border stripe class="custom-table"
										header-cell-class-name="custom-header">
											<el-table-column prop="record_name" label="Summary" />
											<el-table-column prop="record_description" label="Description" />
											<el-table-column label="Requires Certification?" prop="" width="120">
												<template slot-scope="scope">
													{{ scope.row.is_certification == 1 ? 'Yes' : 'No' }}
												</template>
											</el-table-column>
										</el-table>
									</div>
								</div>
								<div class="center-close">
									<el-button type="primary" size="medium" @click="handleClose">
										Cancel
									</el-button>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--签名弹框-->
		<el-dialog title="Cancel Task for Self-Completed Training" :visible.sync="dialogVisible" width="30%">
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
						Please complete the following information
					</div>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
						<div class="input_el">
							<div class="tit required">
								Comments
							</div>
							<el-form-item label="" prop="remark">
								<el-input
									type="textarea"
									:rows="3"
									v-model="ruleForm.remark"
									placeholder="Please enter"
									clearable>
								</el-input>
							</el-form-item>
						</div>
		
						<div class="input_el">
							<div class="tit required">
								Password
							</div>
							<el-form-item label="" prop="signature">
								<el-input
									v-model="ruleForm.signature"
									placeholder="Please enter"
									clearable
									show-password>
								</el-input>
							</el-form-item>
						</div>
					</el-form>
				</div>
		
				<div class="btn_box">
					<van-button class="btn_el" type="default" round @click="dialogVisible = false">
						Cancel
					</van-button>
		
					<van-button
						class="btn_el"
						round
						color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm('ruleForm')">
						Sign
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!--签名弹框-->
		<!--修改培训/认证截止日期弹框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible1" width="30%">
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
						Please complete the following information
					</div>
					<el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="0px">
						<div class="input_el">
							<div class="tit required">
								{{ dateLabel }}
							</div>
							<el-form-item label="" prop="effective_time">
								<el-date-picker
									v-model="ruleForm1.effective_time"
									type="date"
									placeholder="Please select"
									style="width: 100%">
								</el-date-picker>
							</el-form-item>
						</div>
		
						<div class="input_el">
							<div class="tit required">
								Reason for Date Change
							</div>
							<el-form-item label="" prop="effective_conditions">
								<el-input
									type="textarea"
									:rows="3"
									v-model="ruleForm1.effective_conditions"
									placeholder="Please enter"
									clearable>
								</el-input>
							</el-form-item>
						</div>
					</el-form>
				</div>
		
				<div class="btn_box">
					<van-button class="btn_el" type="default" round @click="dialogVisible1 = false">
						Cancel
					</van-button>
		
					<van-button
						class="btn_el"
						round
						color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm1('ruleForm1')">
						Confirm
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!--修改培训/认证截止日期弹框-->
		<!--选人弹窗-->
		<UserMultiple :visible.sync="userDialogVisible" :user-list="userList" :selected-ids="userIds" @confirm="handleUserConfirm" />
		<!--选人弹窗-->
		<!--分配用户完善信息弹框-->
		<el-dialog title="Add Training Requirements for Selected Users" :visible.sync="userVisible" width="55%">
		  <addUser
		    v-if="userVisible"
		    :recordId="Number(recordId)"
		    :recordName="recordName"
		    :userIds="userIds"
		    :userRows="userRows"
			:type="pageType"
			@update-data="handleUserConfirmYes"
		  ></addUser>
		</el-dialog>
		<!--分配用户完善信息弹框-->
		<!--通用培训编辑用户弹框-->
		<el-dialog :title="dialogVisible2Title" :visible.sync="dialogVisible2" width="30%">
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
						Please complete the following information
					</div>
					<el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="0px">
						<div class="input_el">
							<div class="tit required">
								Is Certification Required?
							</div>
							<el-form-item label="" prop="is_certification">
								<el-select
									v-model="ruleForm2.is_certification"
									placeholder="Please select"
									style="width: 100%">
									<el-option label="Yes" :value="1"></el-option>
									<el-option label="No" :value="2"></el-option>
								</el-select>
							</el-form-item>
						</div>
		
						<div v-if="ruleForm2.is_certification == 1" class="input_el">
							<div class="tit required">
								Certification Due Date
							</div>
							<el-form-item label="" prop="certification_end_time">
								<el-date-picker
									v-model="ruleForm2.certification_end_time"
									type="date"
									placeholder="Please select"
									style="width: 100%">
								</el-date-picker>
							</el-form-item>
						</div>
					</el-form>
				</div>
		
				<div class="btn_box">
					<van-button class="btn_el" type="default" round @click="dialogVisible2 = false">
						Cancel
					</van-button>
					<van-button
						class="btn_el"
						round
						color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm2('ruleForm2')">
						Confirm
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!--通用培训编辑用户弹框-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
	trainRecordDetail,
	trainRecordDelUser,
	trainAssignedCancel,
	trainEditEndtime,
	trainEditCertificationEndtime,
} from '@/api/trainManage/configTrain/trainRecord/index';
import {
	trainGerenalDetail,
	trainGerenaldelUser,
	trainGerenaleditUser
} from '@/api/trainManage/configTrain/generalTrain/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import addUser from "./add-user.vue"
import UserMultiple from "@/component/user-multiple.vue";
import { usersList } from "../../../../api/system/user";
import moment from 'moment';
import md5 from 'js-md5';
export default {
	components: {
		headers,
		slider,
		UserMultiple,
		addUser
	},
	data() {
		return {
			isLoading: true,
			dialogVisible: false,
			dialogVisible1: false,
			dialogVisible2: false,
			userDialogVisible: false,
			dialogVisible2Title: '',
			dialogType: "train",
			userList: [],
			userIds: [],
			unfinishedSelections: [],
			unverifiedSelections: [],
			unfinishedList: [],
			unverifiedList: [],
			assignedList: [],
			trainingRequirementList: [],
			sourceData: [],
			ruleForm: {
				remark: "",
				signature: "",
			},
			rules: {
				remark: [{ required: true, message: "Please enter", trigger: "blur" }],
				signature: [{ required: true, message: "Please enter", trigger: "blur" }],
			},
			ruleForm1: {
				effective_time: "",
				effective_conditions: "",
			},
			rules1: {
				effective_time: [{ required: true, message: "Please select", trigger: "change" } ],
				effective_conditions: [{ required: true, message: "Please enter", trigger: "blur" } ],
			},
			ruleForm2: {
				id: null,
				is_certification: "",
				certification_end_time: "",
			},
			rules2: {
				is_certification: [{ required: true, message: "Please select", trigger: "change" } ],
				certification_end_time: [{ required: true, message: "Please select", trigger: "change" } ],
			},
			pageType: "",
			recordId: null,
			recordName: '',
			infoData: null,
			userVisible: false,
			userIds: [],
			userRows: []
		};
	},
	created() {
		let that = this;
		that.pageType = that.$route.query.type;
		that.recordId = that.$route.query.recordId;
		that.recordName = decodeURIComponent(that.$route.query.recordName);
	},
	computed: {
		dialogTitle() {
			let that = this;
			return that.dialogType === "train" ? "Modify Training Due Date": "Modify Certification Due Date";
		},
		dateLabel() {
			let that = this;
			return that.dialogType === "train" ? "New Training Requirement Due Date": "New Certification Due Date";
		},
		pageTitle() {
			let that = this;
			return that.pageType === "overview" ? "Manage Training for General Training Items": "Manage Training for Training Records";
		},
		canEditButton() {
			let that = this;
			return that.unfinishedList.length > 0;
		},
		unverifiedBtn() {
			let that = this;
			return that.unverifiedList.length > 0;
		}
	},
	mounted() {
		let that = this;
		//请求页面数据
		if(that.pageType == 'demand') {
			//档案
			trainRecordDetail({ id: that.recordId }).then(res => {
				if(res.code == 200) {
					usersList({
						page: 1,
						page_size: 99999,
						uids: res.data.uids
					}).then((res2) => {
						if(res2.code == 200) {
							that.userList = res2.data.data;
							that.infoData = res.data;
							that.isLoading = false;
							// console.log(that.infoData);
							that.assignedList = that.infoData.userlist;  //被分配此培训要求的用户
							that.unfinishedList = that.infoData.trainlist;  //未完成的培训
							that.unverifiedList = that.infoData.certlist;  //未完成认证
							that.trainingRequirementList = that.infoData.requirements_list;  //培训要求
						}
					});
				}
			});
		}else if(that.pageType == 'overview') {
			//通用
			trainGerenalDetail({ id: that.recordId }).then(res => {
				if(res.code == 200) {
					usersList({
						page: 1,
						page_size: 99999,
						uids: res.data.uids
					}).then((res2) => {
						if(res2.code == 200) {
							that.userList = res2.data.data;
							that.infoData = res.data;
							that.isLoading = false;
							// console.log(that.infoData);
							that.assignedList = that.infoData.userlist;  //被分配此培训要求的用户
							that.unfinishedList = that.infoData.trainlist;  //未完成的培训
							that.unverifiedList = that.infoData.certlist;  //未完成认证
							that.sourceData = that.infoData.record_list;  //培训要求
						}
					});
				}
			});
		}
	},
	methods: {
		//时间戳转换
		initTime(value) {
			if(value) {
				return moment(value * 1000).format('YYYY-MM-DD');
			}
		},
		handleUnfinishedSelectionChange(val) {
			this.unfinishedSelections = val;
		},
		handleUnverifiedSelectionChange(val) {
			this.unverifiedSelections = val;
		},
		//标记培训完成
		handleMarkComplete() {
			let that = this;
			if(!that.unfinishedSelections.length) {
				return that.$message.warning("You must select at least one training record.");
			}
			let assignedCompleteUser = that.unfinishedSelections.some(item => item.is_assigned == 1);
			if(!assignedCompleteUser) {
				let idStr = that.unfinishedSelections.map(item => item.id).join(',');
				that.$router.push({ path: "/TrainControl/assign-complete", query: { type: "train", ids: idStr } });
			}else {
				that.$message.warning("Error - One or more selected training items have already been assigned to users for completion.");
			}
		},
		//修改培训截止日期
		handleChangeDeadline() {
			let that = this;
			if (!that.unfinishedSelections.length) {
				return that.$message.warning("You must select at least one training record.");
			}
			that.dialogVisible1 = true;
			that.dialogType = "train";
		},
		//指派用户自行完成培训
		handleAssignSelfComplete() {
			let that = this;
			if (!that.unfinishedSelections.length) {
				return that.$message.warning("You must select at least one training record.");
			}
			let assignedCompleteUser = that.unfinishedSelections.some(item => item.is_assigned == 1);
			if(!assignedCompleteUser) {
				let idStr = that.unfinishedSelections.map(item => item.id).join(',');
				that.$router.push({ path: "/TrainControl/assign-complete", query: { type: "assignment", ids: idStr } });
			}else {
				that.$message.warning("Error - One or more selected training items have already been assigned to users for completion.");
			}
		},
		// 取消自行完成培训的指派
		handleCancelAssignSelfComplete() {
			let that = this;
			if (!that.unfinishedSelections.length) {
				return that.$message.warning("You must select at least one training record.");
			}
			let assignedCompleteUser = that.unfinishedSelections.some(item => item.is_assigned == 1);
			if(assignedCompleteUser) {
				that.dialogVisible = true;
			}else {
				that.$message.warning("Error - One or more selected training items have not been assigned to users for completion.");
			}
		},
		// 记录认证进度（功能判断条件）
		isAllSame(arr) {
			if (arr.length === 0) return true;
			const sortArr = (list) => (list || []).slice().sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
			const first = arr[0];
			return arr.every(item => {
				return (
					(item.certification_method || '') === (first.certification_method || '') &&
					JSON.stringify(sortArr(item.image_list)) === JSON.stringify(sortArr(first.image_list))
				);
			});
		},
		// 记录认证进度
		handleCerProgress() {
			let that = this;
			if (!that.unverifiedSelections.length) {
				return that.$message.warning("You must select at least one training record.");
			}
			// 认证方法 & 认证文件必须相同
			if(that.isAllSame(that.unverifiedSelections)) {
				let idStr = that.unverifiedSelections.map(item => item.id).join(',');
				that.$router.push({ path: "/TrainControl/certification-progress", query: { ids: idStr } });
			}else {
				that.$message.warning("Error - The certification method and certification evidence files must be the same for all selected training items.");
			}
		},
		// 标记认证完成（功能判断条件）
		hasEmpty(arr) {
			return arr.some(item => {
				const methodEmpty = typeof item.certification_method !== 'string' || item.certification_method.trim() === '';
				const imageEmpty = !Array.isArray(item.image_list) || item.image_list.length === 0;
				return methodEmpty || imageEmpty;
			});
		},
		// 标记认证完成
		handleCerComplete() {
			let that = this;
			if (!that.unverifiedSelections.length) {
				return that.$message.warning("You must select at least one training record.");
			}
			// 认证方法 & 认证文件不能为空
			if(!that.hasEmpty(that.unverifiedSelections)) {
				let idStr = that.unverifiedSelections.map(item => item.id).join(',');
				that.$router.push({ path: "/TrainControl/assign-complete", query: { type: "certification", ids: idStr } });
			}else {
				that.$message.warning("Error - One or more selected training items do not have a certification method and certification evidence files assigned.");
			}
		},
		//修改认证所需截止日期
		handleCerDeadline() {
			let that = this;
			if (!that.unverifiedSelections.length) {
				return that.$message.warning("You must select at least one training record.");
			}
			that.dialogVisible1 = true;
			that.dialogType = "cert";
		},
		//点击分配用户
		handleUserConfirm(data) {
			let that = this;
			that.userIds = data.ids;
			that.userRows = data.users;
			that.userVisible = true;
		},
		//点击分配用户确定
		handleUserConfirmYes() {
			let that = this;
			window.location.reload();
		},
		handleClose() {
			let that = this;
			that.$router.back();
		},
		//通用编辑用户
		handleEdit(row) {
			let that = this;
			that.dialogVisible2Title = 'Edit User Training Requirement - ' + row.username;
			that.ruleForm2.id = row.id;
			that.ruleForm2.is_certification = Number(row.is_certification);
			that.dialogVisible2 = true;
		},
		handleDelete(row) {
			let that = this;
			that.$confirm('Delete this user?', 'Confirmation', {
				type: 'warning'
			}).then(() => {
				that.$toast.loading({ duration: 0, forbidClick: true });
				if(that.pageType == 'demand') {
					//档案
					trainRecordDelUser({ id: row.id }).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success('Operation successful');
							setTimeout(() => {
								window.location.reload();
							}, 800);
						}
					});
				}else if(that.pageType == 'overview') {
					//通用
					trainGerenaldelUser({ id: row.id }).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success('Operation successful');
							setTimeout(() => {
								window.location.reload();
							}, 800);
						}
					});
				}
			}).catch(() => {});
		},
		handleAssignOtherUser() {
			let that = this;
			that.userDialogVisible = true;
		},
		//取消自行完成培训的指派提交
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					let idStr = that.unfinishedSelections.map(item => item.id).join(',');
					that.$toast.loading({ duration: 0, forbidClick: true });
					trainAssignedCancel({
						ids: idStr,
						remark: that.ruleForm.remark,
						signature: md5(that.ruleForm.signature+'AiisoQms2026')
					}).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success('Operation successful');
							setTimeout(() => {
								window.location.reload();
							}, 800);
						}
					});
				}else {
					return false;
				}
			});
		},
		//修改培训截止日期确定 || 修改认证所需截止日期
		submitForm1(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					if(that.dialogType == 'train') {
						//修改培训截止日期
						let idStr = that.unfinishedSelections.map(item => item.id).join(',');
						that.$toast.loading({ duration: 0, forbidClick: true });
						trainEditEndtime({
							train_ids: idStr,
							new_time: moment(that.ruleForm1.effective_time).valueOf() / 1000,
							justification: that.ruleForm1.effective_conditions
						}).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation successful');
								setTimeout(() => {
									window.location.reload();
								}, 800);
							}
						});
					}else if(that.dialogType == 'cert') {
						//修改认证所需截止日期
						let idStr = that.unverifiedSelections.map(item => item.id).join(',');
						that.$toast.loading({ duration: 0, forbidClick: true });
						trainEditCertificationEndtime({
							train_ids: idStr,
							new_time: moment(that.ruleForm1.effective_time).valueOf() / 1000,
							justification: that.ruleForm1.effective_conditions
						}).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation successful');
								setTimeout(() => {
									window.location.reload();
								}, 800);
							}
						});
					}
				} else {
					return false;
				}
			});
		},
		//通用培训模块编辑用户认证状态
		submitForm2(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					that.$toast.loading({ duration: 0, forbidClick: true });
					trainGerenaleditUser({
						id: that.ruleForm2.id,
						is_certification: that.ruleForm2.is_certification,
						certification_end_time: that.ruleForm2.is_certification == 1 ? moment(that.ruleForm2.certification_end_time).valueOf() / 1000 : ''
					}).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success('Operation successful');
							setTimeout(() => {
								window.location.reload();
							}, 800);
						}
					});
				}else {
					return false;
				}
			});
		},
		//详情
		handleInfo(row) {
			let that = this;
			const routeData = that.$router.resolve({ path: '/TrainControl/record-detail', query: { id: row.id } });
			window.open(routeData.href, "_blank");
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
//保存签名
.save_box {
  .btn_box {
    text-align: right;
    .btn_el {
      margin-left: 10px;
      padding: 12px 24px;
      .van-button__text {
        font-size: 16px;
      }
    }
  }
  .form_box {
    .input_el {
      .tit {
        padding-bottom: 5px;
        font-size: 14px;
        color: #333333;
      }
      .required::before {
        content: "*";
        color: red;
        margin-right: 2px;
      }
    }
  }
}
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-page {
  padding: 12px;
  min-height: 100vh;
  box-sizing: border-box;
  color: #303133;
}

.top-info {
  margin-bottom: 24px;
}

.info-item {
  margin-bottom: 8px;
}

.info-label {
  font-size: 15px;
  font-weight: 400;
  color: #303133;
  line-height: 1.5;
}

.info-link {
  margin-top: 8px;
}

.top-actions {
  margin-top: 16px;
}

.card-block {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
}

.block-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-bottom: 1px solid #dcdfe6;
  background: #fff;
}

.block-title {
  font-size: 20px;
  font-weight: 700;
  color: #303133;
}

.block-search {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 210px;
}

.collapse-btn {
  padding: 9px;
}

.custom-table ::v-deep .el-table__header-wrapper th {
  background: #fff;
  color: #303133;
  font-weight: 700;
}

.custom-table ::v-deep .el-table__row td {
  height: 54px;
}

.custom-table ::v-deep .el-table th,
.custom-table ::v-deep .el-table td {
  padding: 10px 8px;
}

.warning-text {
  margin: 18px 0 10px 0;
  color: #f56c6c;
  font-size: 16px;
  font-weight: 700;
  padding: 0 10px;
}

.center-warning {
  text-align: center;
  color: #f56c6c;
  font-size: 16px;
  font-weight: 700;
  margin: 12px 0 10px;
}

.action-row {
  padding: 10px 10px 16px;
}

.action-row .el-button {
  margin-right: 8px;
  margin-bottom: 8px;
}

.center-close {
  text-align: center;
  padding-bottom: 18px;
}

.mt16 {
  margin-top: 16px;
}

.mt24 {
  margin-top: 24px;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

